import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI, formatApiErrorDetail } from '../api';

export const ForgotPasswordPage = () => {
  const [identifier, setIdentifier] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await authAPI.forgotPassword(identifier.trim());
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-[#0B0F19] dark:to-[#131A2B] p-4">
      <div className="w-full max-w-md">
        <div className="clay-card p-8" data-testid="forgot-password-page">
          <h1 className="text-3xl font-outfit font-semibold text-primary mb-2">Reset Password</h1>
          <p className="text-slate-600 dark:text-slate-400 mb-6 text-sm">Enter your User ID or email and we'll send a secure reset link.</p>
          {sent ? (
            <div className="space-y-4" data-testid="forgot-password-success">
              <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-300 px-4 py-3 rounded-lg text-sm">
                If the account exists, a password reset link has been sent. In this dev environment email delivery is disabled — check backend logs for the reset link.
              </div>
              <Link to="/login" className="text-primary hover:underline text-sm">Back to login</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              {error && <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>}
              <div>
                <label className="block text-sm font-medium mb-2">User ID or Email</label>
                <input value={identifier} onChange={(e) => setIdentifier(e.target.value)} data-testid="forgot-identifier"
                  className="w-full px-4 py-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-900" placeholder="GNONS0007 or you@company.com" required />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 rounded-lg disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <Link to="/login" className="block text-center text-primary hover:underline text-sm">Back to login</Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
export default ForgotPasswordPage;
